
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/galleries",
      function () {
        return require("private-next-pages/galleries/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/galleries"])
      });
    }
  